import camelCase from 'lodash.camelcase'
import transformObjectKeys from './transformObjectKeys'

export default function camelCaseObjectKeys(object) {
  return transformObjectKeys(object, camelCase)
}
